// extracted by mini-css-extract-plugin
module.exports = {"Bolli":"Bolli__Bolli__[hash_base64-5]","Title":"Bolli__Title__[hash_base64-5]"};